/**
 * Dropbox OAuth Configuration
 *
 * Configuration constants and helpers for Dropbox OAuth
 */

/**
 * Dropbox OAuth discovery document endpoints
 * Dropbox uses standard OAuth 2.0 with PKCE support
 */
export const DROPBOX_DISCOVERY = {
  authorizationEndpoint: 'https://www.dropbox.com/oauth2/authorize',
  tokenEndpoint: 'https://api.dropboxapi.com/oauth2/token',
  revocationEndpoint: 'https://api.dropboxapi.com/2/auth/token/revoke',
};

/**
 * Token access type for Dropbox OAuth
 * - 'offline': Returns a refresh token for long-lived access
 * - 'online': Returns only a short-lived access token
 */
export const DROPBOX_TOKEN_ACCESS_TYPE = 'offline';

/**
 * Dropbox OAuth app configuration
 */
export interface DropboxConfig {
  appKey: string;
}

/**
 * Get Dropbox OAuth app key from environment variables
 *
 * Environment variables:
 * - EXPO_PUBLIC_DROPBOX_APP_KEY: Dropbox app key (client ID)
 *
 * Note: Dropbox uses a single app key for all platforms,
 * unlike Google which requires separate client IDs per platform
 */
export const getDropboxConfig = (): DropboxConfig => ({
  appKey: process.env.EXPO_PUBLIC_DROPBOX_APP_KEY || '',
});

/**
 * Check if Dropbox OAuth is configured with required credentials
 * Returns true if the app key is available
 */
export const isDropboxConfigured = (): boolean => {
  const config = getDropboxConfig();
  return !!config.appKey;
};
